import React, { useMemo } from "react";

import { Theme, useTheme } from "@mui/material/styles";

import {
  FullWidthFieldContainer,
  FullWidthTextField,
  SingleItemRowContainer,
  logDebug,
  mergeProperties,
  packableDeepClone,
} from "packable-components";
import { OrderActionsProps, ShippingStatus } from "./Order.types";
import { Grid, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import OrderStatus from "./OrderStatus";

const getStyles = (theme: Theme) => ({
  OrderActionContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  PackableSalectableChip: {
    muiSize: "small",
  },
});

export const OrderLabelsShippedActions: React.FC<OrderActionsProps> = (
  props
): React.JSX.Element => {
  const { orderItemAction, onOrderItemActionUpdate, styles } = props;

  logDebug("OrderLabelsShippedActions PROPS");
  logDebug(props);

  const theme = useTheme();

  const defaultStyles = useMemo(() => getStyles(theme), [theme]);
  const effectiveStyles = useMemo(
    () =>
      styles === undefined
        ? defaultStyles
        : mergeProperties(defaultStyles, styles),
    [defaultStyles, styles]
  );

  logDebug("OrderLabelsShippedActions effectiveStyles");
  logDebug(effectiveStyles);

  const handleTrackingNumberValueChange = (event: any) => {
    let newOrderItemAction = packableDeepClone(orderItemAction);
    newOrderItemAction.trackingNumber = event.target.value;
    onOrderItemActionUpdate(newOrderItemAction);
  };

  const handleNoteValueChange = (event: any) => {
    let newOrderItemAction = packableDeepClone(orderItemAction);
    newOrderItemAction.note = event.target.value;
    onOrderItemActionUpdate(newOrderItemAction);
  };

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    selection: ShippingStatus
  ) => {
    let newOrderItemAction = packableDeepClone(orderItemAction);
    newOrderItemAction.shippingStatus = selection;
    onOrderItemActionUpdate(newOrderItemAction);
  };

  const children = [
    <ToggleButton
      value={ShippingStatus.LABELS_SHIPPED}
      key={ShippingStatus.LABELS_SHIPPED}
    >
      <OrderStatus
        status={ShippingStatus.LABELS_SHIPPED}
        isAdmin={true}
        displayChipForZeroCount
        disabled={
          orderItemAction.shippingStatus !== ShippingStatus.LABELS_SHIPPED
        }
        styles={effectiveStyles}
      />
    </ToggleButton>,
    <ToggleButton
      value={ShippingStatus.LABELS_DELIVERED}
      key={ShippingStatus.LABELS_DELIVERED}
    >
      <OrderStatus
        status={ShippingStatus.LABELS_DELIVERED}
        isAdmin={true}
        label="Labels Delivered"
        displayChipForZeroCount
        disabled={
          orderItemAction.shippingStatus !== ShippingStatus.LABELS_DELIVERED
        }
        styles={effectiveStyles}
      />
    </ToggleButton>,
  ];

  const control = {
    value: orderItemAction.shippingStatus,
    onChange: handleChange,
    exclusive: true,
  };

  return (
    <>
      <Grid sx={effectiveStyles.OrderActionContainer}>
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <ToggleButtonGroup size="small" {...control} aria-label="Small sizes">
            {children}
          </ToggleButtonGroup>
        </Stack>
        {orderItemAction.shippingStatus !== ShippingStatus.LABELS_SHIPPED && (
          <SingleItemRowContainer
            styles={{ PackableSingleItemRowContainer: { pt: 2 } }}
          >
            <FullWidthFieldContainer>
              <FullWidthTextField
                id="note"
                label="Note"
                value={orderItemAction.note}
                onChange={handleNoteValueChange}
              />
            </FullWidthFieldContainer>
          </SingleItemRowContainer>
        )}
      </Grid>
    </>
  );
};

export default OrderLabelsShippedActions;
